import { createUseStyles } from "react-jss";
import { ITheme } from "../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 24,
    height: "100vh",
    overflowY: "scroll",
    background: "#0b0b0f",
    color: "white",
    position: "relative",
    boxSizing: "border-box",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch",
  },
  logo: {
    display: "flex",
    height: 30,
    justifyContent: "center",
    alignItems: "center",
  },
  skipTxt: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "16px !important",
    lineHeight: "140%",
    padding: "8px 16px",
  },
  buttonWrapper: {
    position: "fixed",
    bottom: "6vh",
    left: 24,
    right: 24,
  },
  space32: {
    height: "4vh",
  },
  marginDes: {
    marginTop: theme.spacing.space4,
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
  scrollContainer: {
    display: "flex",
    flexDirection: "row",
    overflowX: "auto",
    scrollSnapType: "x mandatory",
    WebkitOverflowScrolling: "touch",
    scrollBehavior: "smooth",
    width: "100%",
    height: "100%",
  },
  imageCtr: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    objectFit: "cover",
    borderRadius: 24,
    width: "auto",
    height: "48vh",
    maxWidth: "86vw",
    maxHeight: "400px",
  },
  "@media (orientation: landscape)": {
    image: {
      height: "36vh",
      maxHeight: "58vh",
      maxWidth: "80vw",
    },
    slide: {
      padding: "0px 8px",
      alignItems: "center",
      justifyContent: "center",
    },
    buttonWrapper: {
      bottom: "5vh",
    },
    textWrapper: {
      marginTop: "3vh !important",
      marginBottom: "8vh !important",
    },
    space32: {
      height: "1vh",
    },
    paginationDots: {
      marginTop: "8px !important",
    },
  },
  "@media (orientation: landscape) and (max-height: 380px)": {
    slide: {
      padding: "0px 4px",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
    },
    header: {
      paddingTop: 4,
      paddingBottom: 4,
      height: 40,
    },
    logo: {
      height: 24,
    },
    skipTxt: {
      fontSize: "14px !important",
      padding: "6px 10px",
    },
    space32: {
      height: "0.5vh",
    },
    textWrapper: {
      marginTop: "2vh !important",
      marginBottom: "6vh !important",
      textAlign: "center",
    },
    marginDes: {
      marginTop: theme.spacing.space2,
      lineHeight: "120%",
    },
    buttonWrapper: {
      bottom: "2.5vh",
      left: 12,
      right: 12,
    },
    buttonImg: {
      width: 20,
      height: 20,
      marginLeft: 6,
    },
    paginationDots: {
      marginTop: 10,
      gap: 4,
      "& span": {
        width: 6,
        height: 6,
      },
      "& .active": {
        width: 12,
      },
    },
    root: {
      padding: 12,
    },
  },
  textWrapper: {
    textAlign: "center",
    marginTop: "5vh",
    marginBottom: "12vh",
  },
  paginationDots: {
    display: "flex",
    gap: 6,
    marginTop: 24,
    "& span": {
      width: 8,
      height: 8,
      borderRadius: "50%",
      background: "gray",
      transition: "all 0.3s ease-in-out",
    },
    "& .active": {
      background: "white",
      width: 16,
      borderRadius: "40%",
    },
    "@media (max-height: 680px)": {
      marginTop: 16,
    },
  },
  buttonImg: {
    width: 24,
    height: 24,
    objectFit: "contain",
    marginLeft: 8,
  },
  slider: {
    width: "100%",
  },
  slide: {
    flex: "0 0 100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0px 1.75px",
  },
}));
